import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useStepbarSteps } from '@/hooks/useStepbarSteps'
import { routeRequirements } from './routeRequirements'

export const useNavigationGuard = () => {
  const pathName = useLocation().pathname

  const { steps } = useStepbarSteps()
  const pathIncludedInSteps = steps.some(
    (step) =>
      step.path !== '/' &&
      pathName.startsWith(step.path) &&
      !pathName.startsWith(`${step.path}-`)
  )

  const nextStep = useMemo(() => {
    let stepToNavigate = '/'

    for (const { completed, disabled, path } of steps) {
      if (disabled) {
        continue
      }

      if (!completed || path === pathName) {
        stepToNavigate = path
        break
      }
    }

    return stepToNavigate
  }, [pathName, steps])

  const canAccessCurrentRoute = useMemo(() => {
    const firstSegment = '/' + pathName.split('/')[1]

    const checker = routeRequirements[firstSegment]
    if (!checker) return true
    return checker(pathName)
  }, [pathName])

  return {
    nextStep,
    pathIncludedInSteps,
    canAccessCurrentRoute,
    pathName
  }
}
